var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircleSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.985352C4.5372 0.985352 0.5 5.02255 0.5 9.98535C0.5 14.9482 4.5372 18.9854 9.5 18.9854C14.4628 18.9854 18.5 14.9482 18.5 9.98535C18.5 5.02255 14.4628 0.985352 9.5 0.985352ZM13.4375 10.7353H5.5625C5.14845 10.7353 4.81255 10.3994 4.81255 9.98535C4.81255 9.5713 5.14845 9.2354 5.5625 9.2354H13.4375C13.8515 9.2354 14.1875 9.5713 14.1875 9.98535C14.1875 10.3994 13.8515 10.7353 13.4375 10.7353Z",
    fill: "#5F5DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleSmall);
export default __webpack_public_path__ + "static/media/MinusCircleSmall.ee591c2cb9650774344d951fc457741c.svg";
export { ForwardRef as ReactComponent };